import _Skeleton from "@mui/material/Skeleton";
import _Box from "@mui/material/Box";
import React from 'react';
export function RoadTypeBar({
  entries,
  values
}) {
  return values ? /*#__PURE__*/React.createElement(_Box, {
    borderRadius: 3,
    display: "flex",
    height: 6,
    overflow: "hidden"
  }, entries.map(({
    key,
    color
  }, index) => {
    const last = index === entries.length - 1;
    return /*#__PURE__*/React.createElement(_Box, {
      flexGrow: last ? 1 : 0,
      flexShrink: 0,
      key: key,
      sx: {
        backgroundColor: color
      },
      title: `${values[index]}%`,
      width: last ? undefined : `${values[index]}%`
    });
  })) : /*#__PURE__*/React.createElement(_Skeleton, {
    height: 6,
    sx: {
      borderRadius: 3
    },
    variant: "rectangular"
  });
}